<ng-container *ngIf="shipment!=null">
 
     <!-- NUMERO DE BULTOS PENDENTS -->
     <div class="requadre pending-packages">
        {{ getNumber(shipment.pendingPackages) }}
    </div>
    <!-- NUMERO TOTAL DE BULTOS ORIGINALS -->
    <div class="requadre total-packages">
       {{ getNumber(shipment.totalPackages) }}
   </div>
    
    <!-- DISPONIBILITAT TD/SD/ND -->
    <div *ngIf="disponibilty" class="requadre" [ngClass]="disponibilty">
        {{ disponibilty }}
    </div>

    <!-- PARTNERS -->
    <div *ngIf="shipment.partnerClientId && shipment.partnerClientTrademark" class="requadre client element">
        <span class="trademark ellipsis">{{ shipment.partnerClientTrademark }}</span>
    </div>
    <div *ngIf="shipment.partnerProviderId && shipment.partnerProviderTrademark" class="requadre provider element">
        <span class="trademark ellipsis">{{ shipment.partnerProviderTrademark }}</span>
    </div>
    
    <!-- DESTÍ -->
    <div *ngIf="shipment.destinationAddressSkin" class="requadre destino element">
        <span class="destino ellipsis">{{ shipment.destinationAddressSkin }}</span>
    </div>

</ng-container>
